import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../../lib/supabase'
import type { CardIconKey } from '@chillout/ui'
import type { LoyaltyConfig } from './useLoyaltyConfig'

async function fetchActiveLoyaltyConfig(): Promise<LoyaltyConfig> {
  const { data, error } = await supabase
    .from('loyalty_config')
    .select('earning_method, amount_per_stamp, stamp_target, completion_reward_item_id, completion_card_icon, milestones')
    .eq('status', 'active')
    .single()

  if (error) throw error

  return {
    earningMethod: data.earning_method as LoyaltyConfig['earningMethod'],
    amountPerStamp: data.amount_per_stamp ?? 0,
    stampTarget: data.stamp_target,
    completionRewardItemId: data.completion_reward_item_id,
    completionCardIcon: data.completion_card_icon as CardIconKey,
    milestones: data.milestones as LoyaltyConfig['milestones'],
  }
}

export function useActiveLoyaltyConfig() {
  return useQuery({
    queryKey: ['loyalty-config'],
    queryFn: fetchActiveLoyaltyConfig,
  })
}